// import { createTheme } from '@mui/material/styles';
import { remCalc } from 'utils/remCalc';
// import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';
import { getColor } from 'utils/colors';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// 	mixins: mixins,
// });

// const collapsePoint = 'sm';

export const overrides = {
	'.Chat-root': {
		'.MuiDialog-paper': {
			height: 'calc(100% - 150px)',
		},
		'.Chat-content': {
			'&:before': {
				margin: remCalc('40 0'),
				display: 'block',
				borderBottom: '1px solid white',
				content: '""',
			},

			'.Chat-log': {
				margin: 0,
				padding: 0,
				listStyle: 'none',
				display: 'flex',
				flexDirection: 'column',
				'.Chat-entry': {
					display: 'flex',
					marginBottom: remCalc(40),
					span: {
						padding: remCalc('0 20'),
						borderRadius: '4px',
						maxWidth: '85%',
						...mixins.glass,
					},
					'&.assistant span': {
						backgroundColor: 'rgba(255, 255, 255, .35)',
					},
					'&.user': {
						justifyContent: 'flex-end',
						span: {
							background: 'white',
							color: getColor('ivory', 800),
						},
					},
				},
			},
		},
	},

	'.Chat-input': {
		'.MuiInputBase-root': {
			'.MuiInputBase-input': {
				'&:-webkit-autofill, &:autofill': {
					'WebkitBoxShadow': `0 0 0 100px white inset`,
					'WebkitTextFillColor': getColor('ivory', 800),
					'CaretColor': getColor('ivory', 800),
				},
			},
			fieldset: {
				border: 'none',
			},
		}
	},

	'.SaveChat-content': {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: remCalc(40),
		'.MuiInputBase-root': {
			'.MuiInputBase-input': {
				'&:-webkit-autofill, &:autofill': {
					'WebkitBoxShadow': `0 0 0 100px white inset`,
					'WebkitTextFillColor': getColor('ivory', 800),
					'CaretColor': getColor('ivory', 800),
				},
			},
		}

	},
}

const styles = {};

export default styles;